import { Link } from "react-router-dom";

export default function DocsNextStep() {
  return (
    <>
      <hr className="docs-hr" />
      <div className="docs-nextstep">
        <div>
          <h3>Ready to try it?</h3>
          <p>Get a free API key and make your first request — free tier, no credit card.</p>
        </div>
        <div className="dns-btns">
          <Link className="dns-primary" to="/dashboard"><i className="fa-solid fa-key" />Get started</Link>
          <Link className="dns-ghost" to="/pricing"><i className="fa-solid fa-tags" />View pricing</Link>
        </div>
      </div>
    </>
  );
}
